<script>
    import {sgettext} from '../i18n.js';

    export let text = sgettext('$$LOADING_$$');
    export let size = 'normal';
    export let inline = false;
    export let homePage = false;
</script>

<style>
    .spinner-border {
        display: flex;
    }

    .spinner-border-lg {
        width: 50px;
        height: 50px;
    }

    .inline {
        display: inline-block;
    }
</style>

<div
    class:inline
    class:spinner-border-sm={size === 'small'}
    class:spinner-border-lg={size === 'large'}
    class="spinner-border text-primary"
    role="status">
    {#if homePage}
        <span style="display: contents;"><p style="margin-left: 50%;">{text}</p></span>
    {:else}
        <span class="sr-only">{text}</span>
    {/if}
</div>
